import { isDefined } from "@clipboard-health/util-ts";
import { generatePath, useHistory } from "react-router-dom";

import { type NCOrientationRequirement } from "../../ShiftDiscovery/NorthCarolinaOrientation/useNCOrientationStatus";
import { DocumentCardsWrapper } from "../components/DocumentCardsWrapper";
import { DocumentOverviewCard } from "../components/OverviewCard";
import { WORKER_REQUIREMENT_STATUS_PILL_VARIANTS } from "../DocumentsPage/constants";
import { DOCUMENT_DETAILS_FULL_PATH } from "../paths";

interface NCOrientationRequirementsListProps {
  orientationRequirements: NCOrientationRequirement[];
}

export function NCOrientationRequirementsList(props: NCOrientationRequirementsListProps) {
  const { orientationRequirements } = props;
  const history = useHistory();

  return (
    <DocumentCardsWrapper>
      {orientationRequirements.flatMap((requirement) => {
        const requirementName = requirement.requirement?.attributes.name;
        if (!isDefined(requirementName)) {
          return [];
        }

        const pillVariant = WORKER_REQUIREMENT_STATUS_PILL_VARIANTS[requirement.status];
        const qualifications = [
          ...new Set(
            requirement.requirementMappings?.flatMap(
              (mapping) => mapping.attributes.qualifications
            ) ?? []
          ),
        ];

        return (
          <DocumentOverviewCard
            key={requirement.requirementId}
            requirementName={requirementName}
            documentStatusPillVariant={pillVariant}
            qualifications={qualifications}
            onClick={() => {
              history.push(
                generatePath(DOCUMENT_DETAILS_FULL_PATH, {
                  requirementId: requirement.requirementId,
                })
              );
            }}
          />
        );
      })}
    </DocumentCardsWrapper>
  );
}
